function isElectron() {
    // Renderer process
    if (typeof window !== 'undefined' && typeof window.process === 'object' && window.process.type === 'renderer') {
        return true;
    }

    // Main process
    if (typeof process !== 'undefined' && typeof process.versions === 'object' && !!process.versions.electron) {
        return true;
    }

    // Detect the user agent when the `nodeIntegration` option is set to true
    if (typeof navigator === 'object' && typeof navigator.userAgent === 'string' && navigator.userAgent.indexOf('Electron') >= 0) {
        return true;
    }

    return false;
}



//get company names
function getCompanyNames(_this,meta) {
    if(meta=="electron"){
        // window.api.send('getCompanyNames_tally'); 
        // window.api.receive("fromMain", (company_obj) => {
        //     _this.company_names = [];
        //     $.each(company_obj,function(key,value){
        //         _this.company_names.push(value);
        //        // $(".company_name").append("<option value=" + value + ">" + value + "</value>");
        //     })
        // }); 

        window.api.getCompanyNamesFromTally();



    }
    else{
        axios.get('fetchCompanyNames')
        .then((result) => {
            console.log("fetchCompanyNames Results",result);
            var companies = [];
            var company_obj = JSON.parse(convert.xml2json(result.data, { compact: true, spaces: 4 }));
            var key = '';
            getCompanyName([company_obj], key,_this);
        });
    }
}

function getCompanyName(arr, key,_this) {
    if (arr) {
        arr.forEach(element => {
            if (Array.isArray(element) == true) {
                var Keys = '';
                getCompanyName(element, Keys);
            }
            else if (typeof element == 'object') {
                //var values = Object.values( element );
                var keys = Object.keys(element);
                var vals = Object.keys(element).map(function (key) {
                    return element[key];
                });
                if (keys.includes("_text") == true) {
                    //arrVchType.push(element.VOUCHERTYPE._attributes.NAME)
                    _this.company_names.items=[]
                    _this.company_names.items.push(element._text);
                    // $(".company_name").append("<option value=" + element._text + ">" + element._text + "</value>");
                }
                else {
                    getCompanyName(vals);
                }
            }
        });
    }
}

function changeSubtype(type){
    if(type=="Voucher"){
        $('#Voucher').css('display','block');
        $('#Master').css('display','none');
    }
    else{
        $('#Voucher').css('display','none');
        $('#Master').css('display','block');
    }; 
}

function checkTallyIsOpenWeb(){

}

function checkTallyIsOpenElectron(_this){
    if(isElectron()){
        window.api.send('checkTallyOpening'); 
        window.api.receive("checkTallyOpening-reply", (tally_response) => {
            if(tally_response == "tally is not open"){
                _this.tally_open_status = "false";
            }
            else if(tally_response == "tally is open"){
                _this.tally_open_status = "true";
            }
        });
    }
    else{
        axios.post('/checkTallyIsOpen')
        .then((result) => {
            if(result.data!="not_open"){
                _this.tally_open_status = "true";
            }
            else{
                _this.tally_open_status = "false";
            }
        })
    }

}

function getCompanyNamesWithIds(_this){
    if(isElectron()){
        window.api.send('getCompanyWithIds'); 
        window.api.receive("getCompanyWithIds-reply", (get_company_response,get_company_ids) => {
            if(get_company_response == "tally is not open"){
                _this.messag = "open tally to select company names";
                _this.isVisible = true; 
            }
            else{   
                _this.company_names = get_company_response;
                _this.company_guids = get_company_ids;
            }
        });
    }
    else{
        axios.post('/checkTallyIsOpen')
        .then((result) => {
            if(result.data!="not_open"){
                _this.tally_open_status = "true";
            }
            else{
                _this.tally_open_status = "false";
            }
        })
    }
}

export {isElectron,changeSubtype,checkTallyIsOpenWeb,checkTallyIsOpenElectron,getCompanyNames,getCompanyNamesWithIds}